var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33203 14H10.6654M7.9987 11.3333V14M4.53203 11.3333H11.4654C12.5855 11.3333 13.1455 11.3333 13.5733 11.1153C13.9497 10.9236 14.2556 10.6176 14.4474 10.2413C14.6654 9.81349 14.6654 9.25344 14.6654 8.13333V5.2C14.6654 4.0799 14.6654 3.51984 14.4474 3.09202C14.2556 2.71569 13.9497 2.40973 13.5733 2.21799C13.1455 2 12.5855 2 11.4654 2H4.53203C3.41193 2 2.85187 2 2.42405 2.21799C2.04773 2.40973 1.74176 2.71569 1.55002 3.09202C1.33203 3.51984 1.33203 4.0799 1.33203 5.2V8.13333C1.33203 9.25344 1.33203 9.81349 1.55002 10.2413C1.74176 10.6176 2.04773 10.9236 2.42405 11.1153C2.85187 11.3333 3.41193 11.3333 4.53203 11.3333Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.48b0ff64782060e66abe4d3f1eb5148a.svg";
export { ForwardRef as ReactComponent };